import { Component, Inject, ViewChild, forwardRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CustomPropertyDefinition } from "../../model";


@Component({
    selector: 'object-array-csv-type-selection-dialog',
    template: require('./object-array-csv-type-selection-dialog.component.html')
})
export class ObjectArrayCsvTypeSelectionDialogComponent {

    @ViewChild('form') form: NgForm;

    typeDefinition: CustomPropertyDefinition;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<ObjectArrayCsvTypeSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.typeDefinition = data.definition;
    }

    save(): void {
        const rawValues = this.form.form.getRawValue();
        this.dialogRef.close(rawValues.type);
    }

}